export default function Divider(props: any) {

    return (
        <div
            className="divider"
            style={{
                display:"inline",
                borderRight: "1px solid #A3D8E7",
                width: "1px"
            }}
        >

        </div>
    )
}